export default __webpack_public_path__ + "static/media/habitgroovylogo.6f060783.png";